import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  states: null,
  status: 'idle',
  error: null,
};

const stateSlice = createSlice({
  name: 'states',
  initialState,
  reducers: {
    getAllStatesStart: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    getAllStatesSuccess: (state, action) => {
      state.status = 'success';
      state.states = action.payload.data;
      state.error = null;
    },
    getAllStatesFailure: (state, action) => {
      state.status = 'fail';
      state.error = action.payload.message;
    },
  },
});

export const { getAllStatesStart, getAllStatesSuccess, getAllStatesFailure } = stateSlice.actions;

export default stateSlice.reducer;
